// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"918":"c11fc0ee9eb233fe","2765":"b1c72a309a487d86","4174":"a13e1e4d3e09292f","5077":"fae44c604a78aee4","6131":"70525e4b9b086fc1"}[chunkId] + ".css";
};